import {Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output, Input} from '@angular/core';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {DeltaChargesModel} from '../../../models/DeltaChargesModel';
import {DeltaChargesService} from './service-delta-charges/delta-charges.service';
import * as toastr from 'toastr';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import { Router } from '@angular/router';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-delta-charges',
  templateUrl: './delta-charges.component.html',
  styleUrls: ['./delta-charges.component.scss']
})
export class DeltaChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isDeltaSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: DeltaChargesModel;
  numAnnoMeseData: any;
  contractTypeData: any;

  updateAllPlains: Subscription;
  enableUpdatePlains: boolean;
  showFilter: boolean;
  listRowSelected: any;
  color: any;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;




  constructor(private deltaChargesService: DeltaChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.sectionId = this.SECTIONS.MONTHLY_CHARGES;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.loaderService.display(true);
  }

  ngOnInit() {
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));

    this.isDeltaSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.listRowSelected = [];
    this.enableUpdatePlains = false;

    this.displayedColumns = ['Status', 'NumAnnoRif','IsClaims', 'IsRecovery',  'regionDesc',
    'localCustomerDesc', 'contractTypeDesc',  'resourceUnitName', 'delta', 'actualMonthCharge',
    'calculatedMonthCharge', 'actions'];

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.DELTA_CHARGES_OFFSET);
    this.getSessionStorageFilter();
    this.setDefaultOrderField();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  init() {
    this.filter.isRecovery = 0;

    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }

        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }          }, error => {
        console.log(error);
        this.loaderService.display(false);
    });
  }

  getDataPage(offset: Offset, filter: DeltaChargesModel) {
    this.getPageSubscribe = this.deltaChargesService.getPage(offset, this.filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.listData.data.forEach(value => {
            this.listRowSelected.forEach(value1 => {
              if (value.id === value1.id) {
                value.isClaims = value1.isClaims;
              }
            });
          });
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const deltaChargesData = this.dataSource.find(data => data.id === id) as DeltaChargesModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(deltaChargesData.numAnnoMese)},
      {id: 'Is Recovery', value: this.toCustomStringIs(deltaChargesData.isRecovery)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese(deltaChargesData.numAnnoMeseRif)},
      {id: 'Provider Cod', value: this.toCustomString(deltaChargesData.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString(deltaChargesData.provider.description)},
      {id: 'Region Cod', value: this.toCustomString(deltaChargesData.region.cod)},
      {id: 'Region Description', value: this.toCustomString(deltaChargesData.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString(deltaChargesData.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString(deltaChargesData.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString(deltaChargesData.contractType.cod)},
      {id: 'Contract Type Description', value: this.toCustomString(deltaChargesData.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString(deltaChargesData.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString(deltaChargesData.resourceUnit.name)},
      {id: 'Delta', value: this.toCustomString(deltaChargesData.delta)},
      {id: 'Actual Month Charge', value: this.toCustomString(deltaChargesData.actualMonthCharge)},
      {id: 'Calculate Month Charge', value: this.toCustomString(deltaChargesData.calculatedMonthCharge)},
      {id: 'Notes', value: this.toCustomString(deltaChargesData.note)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  openNotes(id: number) {
    const discountData = this.dataSource.find(data => data.id === id);
    const list: GenericArray[] = [
      {id: 'Note', value: discountData.note === null ? 'N.D.' : discountData.note}
    ];
    const note = true;
    const serviceType = 'charges';
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list, note, discountData, serviceType}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getDataPage(this.offset, this.filter);
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.DELTA_CHARGES_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
    if (this.updateAllPlains) {
      this.updateAllPlains.unsubscribe();
    }
  }

  highlight(row) {
    this.enableUpdatePlains = true;
    row.isClaims = row.isClaims === 0 ? row.isClaims = 1 : row.isClaims = 0;
    this.listRowSelected.push(row);
    this.listData.data.forEach(value => {
      if (value.id === row.id) {
        value = this.listRowSelected.find(value1 => value1.id === row.id);
      }
    } );
  }

  updateClaims() {
    this.updateAllPlains = this.deltaChargesService.updateAllClaims(this.listRowSelected)
      .subscribe(
        (result: any) => {
          this.enableUpdatePlains = false;
          toastr.success('Plains updated with success', 'Success');
          this.getDataPage(this.offset, this.filter);
        }, error => {
          toastr.error('A problem has occurred, please contact the Administrator', 'Error');
        }
      );
  }

  checkDelta(row) {
    let color: string;
    if (row.isDeltaSignificativo === 0) {
      color = ' #83da5b transparent';
    } else {
      color = '#e6e600 transparent';
    }

    if (row.isClaims === 1) {
      color = '#da5b5b transparent';
    }

    return color;
  }

  private setDefaultOrderField() {
    if (this.offset.orderField === null || this.offset.orderField === undefined || this.offset.orderField === '') {
      this.offset.orderField = 'contractTypeDesc';
      this.offset.orderDirection = 'asc';
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  isClaimsDisabled(row: any) {
    if (!this.canUpdate || row.isConsolidated === 1) {
      return true;
    }
    return false;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DELTA_CHARGES_FILTER));
    this.filter = filter_ ? filter_ : new DeltaChargesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
  }
}
